import { createSelector } from '@reduxjs/toolkit';
import { STAFF_ROLE_IDS } from 'config/roleDisplay';

// Selector for getting all roles by Organization
export const selectRoles = createSelector(
	[(state) => state.Roles.data, (state) => state.Auth.selectedProfile.orgID],
	(rolesData, orgID) => rolesData?.[orgID] || []
);

// Staff allowlist flag, resolved server-side on the self-profile fetch; absent or invalid → false.
export const selectIsPlatformDeveloper = (state) => state.Auth.selectedProfile?.isPlatformDeveloper === true;

// Zezamii staff: the platform developer flag, or a staff role (Developer) in the selected org.
export const selectHasDeveloperAccess = createSelector(
	[selectIsPlatformDeveloper, (state) => state.Auth.selectedProfile?.roles],
	(isPlatformDeveloper, roles) =>
		isPlatformDeveloper ||
		Object.keys(roles || {})
			.map(Number)
			.some((id) => STAFF_ROLE_IDS.includes(id))
);
